export default "<router-outlet  (activate)=\"changeOfRoutes()\"></router-outlet>"